<div class="packages-table-container mt-2">
    @if (packages().length === 0) {
        <div class="no-packages text-center p-2">
            <span i18n>No packages yet.  Please add a package to this shipment.</span>
        </div>
    } @else {
        <table mat-table [dataSource]="packages()" [trackBy]="trackBy" class="packages-table">

            <!-- Selection -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="toggleSelection()" [checked]="isAllSelected()" [indeterminate]="isSelectionIndeterminate()"></mat-checkbox>
                </th>
                <td mat-cell class="checkbox" *matCellDef="let pkg; let i = index">
                    <mat-checkbox
                            class="selector"
                            color="primary"
                            [checked]="isSelected(i)"
                            (change)="toggleSelectRow(i)"
                    ></mat-checkbox>
                </td>
            </ng-container>

            <!-- Quantity -->
            <ng-container matColumnDef="quantity">
                <th mat-header-cell class="number max-w-12 min-w-12" *matHeaderCellDef i18n>Qty</th>
                <td mat-cell class="number max-w-12 min-w-12" *matCellDef="let pkg; let i = index">
                    <input class="w-full" matInput type="number" min="1" [value]="pkg.quantity || 1" (blur)="onFieldBlur(i, 'quantity', $event)">
                </td>
            </ng-container>

            <!-- Description -->
            <ng-container matColumnDef="description">
                <th mat-header-cell class="text min-w-18" *matHeaderCellDef i18n>Description</th>
                <td mat-cell class="text w-30 min-w-18" *matCellDef="let pkg; let i = index">
                    <input class="w-full" matInput type="text" [value]="pkg.description" (blur)="onFieldBlur(i, 'description', $event)">
                </td>
            </ng-container>

            <!-- Code -->
            <ng-container matColumnDef="packageCode">
                <th mat-header-cell class="select max-w-30 min-w-20" *matHeaderCellDef i18n>Packaging</th>
                <td mat-cell class="select max-w-30 min-w-20" *matCellDef="let pkg; let i = index">
                    <input class="w-full" matInput type="text" [matAutocomplete]="packageCodeAuto" [value]="pkg.packageCode" (blur)="onFieldBlur(i, 'packageCode', $event)">
                    <mat-autocomplete #packageCodeAuto="matAutocomplete">
                        @for (choice of packageCodeChoices; track choice) {
                            <mat-option [value]="choice.value">
                                {{ choice.label }}
                            </mat-option>
                        }
                    </mat-autocomplete>
                </td>
            </ng-container>

            <!-- Stackable (boolean shown as text field) -->
            <ng-container matColumnDef="stackable">
                <th mat-header-cell class="checkbox max-w-18 min-w-18" *matHeaderCellDef i18n>Stackable</th>
                <td mat-cell class="checkbox max-w-18 min-w-18" *matCellDef="let pkg; let i = index">
                    <div class="checkbox">
                        <mat-checkbox class="selector" [checked]="pkg.stackable" (change)="onCheckbox(i, 'stackable', $event.checked)"></mat-checkbox>
                    </div>
                </td>
            </ng-container>

            <!-- Weight -->
            <ng-container matColumnDef="weight">
                <th mat-header-cell class="number max-w-16 min-w-14" *matHeaderCellDef i18n>Weight</th>
                <td mat-cell class="number max-w-16 min-w-14" *matCellDef="let pkg; let i = index">
                    <input matInput type="number" class="w-full" min="1" [value]="pkg.weight | digits" (blur)="onFieldBlur(i, 'weight', $event)">
                </td>
            </ng-container>

            <!-- Length -->
            <ng-container matColumnDef="length">
                <th mat-header-cell class="number max-w-16 min-w-14" *matHeaderCellDef i18n>Length</th>
                <td mat-cell class="number max-w-16 min-w-14" *matCellDef="let pkg; let i = index">
                    <input matInput type="number" class="w-full" min="1" [value]="pkg.length | digits" (blur)="onFieldBlur(i, 'length', $event)">
                </td>
            </ng-container>

            <!-- Width -->
            <ng-container matColumnDef="width">
                <th mat-header-cell class="number max-w-16 min-w-14" *matHeaderCellDef i18n>Width</th>
                <td mat-cell class="number max-w-16 min-w-14" *matCellDef="let pkg; let i = index">
                    <input matInput type="number" class="w-full" min="1" [value]="pkg.width | digits" (blur)="onFieldBlur(i, 'width', $event)">
                </td>
            </ng-container>

            <!-- Height -->
            <ng-container matColumnDef="height">
                <th mat-header-cell class="number max-w-16 min-w-14" *matHeaderCellDef i18n>Height</th>
                <td mat-cell class="number max-w-16 min-w-14" *matCellDef="let pkg; let i = index">
                    <input matInput type="number" class="w-full" min="1" [value]="pkg.height | digits" (blur)="onFieldBlur(i, 'height', $event)">
                </td>
            </ng-container>

            <!-- Value -->
            <ng-container matColumnDef="value">
                <th mat-header-cell class="number max-w-20 min-w-14" *matHeaderCellDef i18n>Decl Value</th>
                <td mat-cell class="number max-w-20 min-w-14" *matCellDef="let pkg; let i = index">
                    <input matInput type="number" class="w-full" min="1" [value]="pkg.value | digits" (blur)="onFieldBlur(i, 'value', $event)">
                </td>
            </ng-container>

            <!-- Freight Class -->
            <ng-container matColumnDef="freightClass">
                <th mat-header-cell class="number max-w-16 min-w-16" *matHeaderCellDef i18n>Freight Class</th>
                <td mat-cell class="number max-w-16 min-w-16" *matCellDef="let pkg; let i = index">
                    <input matInput [placeholder]="defaultFreightClass(pkg)" [matAutocomplete]="freightClassAuto" type="text" class="w-full show-placeholder" [value]="pkg.freightClass || ''" (blur)="onFieldBlur(i, 'freightClass', $event)">
                    <mat-autocomplete #freightClassAuto="matAutocomplete">
                        @for (choice of freightClasses; track choice) {
                            <mat-option [value]="choice.value">
                                {{ choice.label }}
                            </mat-option>
                        }
                    </mat-autocomplete>
                </td>
            </ng-container>

            <!-- Hazardous Category -->
            <ng-container matColumnDef="hazmatClass">
                <th mat-header-cell class="number max-w-14 min-w-14" *matHeaderCellDef i18n>Hazmat Class</th>
                <td mat-cell class="number max-w-14 min-w-14" *matCellDef="let pkg; let i = index">
                    <input matInput [matAutocomplete]="hazmatClassAuto" type="text" class="w-full" [value]="pkg.hazmatClass || ''" (blur)="onFieldBlur(i, 'hazmatClass', $event)">
                    <mat-autocomplete #hazmatClassAuto="matAutocomplete">
                        @for (choice of hazmatClasses; track choice) {
                            <mat-option [value]="choice.value">
                                {{ choice.label }}
                            </mat-option>
                        }
                    </mat-autocomplete>
                </td>
            </ng-container>

            <!-- UN Number -->
            <ng-container matColumnDef="unNumber">
                <th mat-header-cell class="number max-w-14 min-w-14" *matHeaderCellDef i18n>UN #</th>
                <td mat-cell class="number max-w-14 min-w-14" *matCellDef="let pkg; let i = index">
                    <input matInput type="text" class="w-full" [value]="pkg.unNumber || ''" (blur)="onFieldBlur(i, 'unNumber', $event)">
                </td>
            </ng-container>

            <!-- NMFC Number -->
            <ng-container matColumnDef="nmfcNumber">
                <th mat-header-cell class="number max-w-14 min-w-14" *matHeaderCellDef i18n>NMFC #</th>
                <td mat-cell class="number max-w-14 min-w-14" *matCellDef="let pkg; let i = index">
                    <input matInput type="text" class="w-full" [value]="pkg.nmfcNumber || ''" (blur)="onFieldBlur(i, 'nmfcNumber', $event)">
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayColumns()"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns()"></tr>
        </table>
    }
</div>

<div class="packages-footer mt-2 mb-2">
    <div class="flex flex-row">
        <div class="buttons">
            <button matButton (click)="addEmptyPackage()" i18n>Add Package</button>
            <button matButton (click)="addTemplatePackage()" i18n>Saved Packages</button>
            <button matButton (click)="deletePackages()" i18n [disabled]="selectedIds.size === 0">Delete</button>
        </div>
        <div class="m-auto">
        </div>
        <div class="information flex flex-row gap-2">
            <div class="summary">
                <div class="property">Total Weight</div>
                <div class="value" [class.highlight]="!dimensionalWeightGreater()">
                    {{ totalActualWeight() | number:'1.1-2' }}
                    <small>{{ weightUnitDisplay() }}</small>
                </div>
            </div>
            <div class="summary">
                <div class="property">Dim. Weight</div>
                <div class="value" [class.highlight]="dimensionalWeightGreater()">
                    {{ totalDimensionalWeight() | number:'1.1-2' }}
                    <small>{{ weightUnitDisplay() }}</small>
                </div>
            </div>
            @if (totalInsurance() > 0) {
                <div class="summary">
                    <div class="property">Total Insurance</div>
                    <div class="value">{{ totalInsurance() | currency:currency() }}</div>
                </div>
            }
        </div>
    </div>
</div>
